/* Product help, contact context, mobile purchase shortcut and specification ordering. */
(function (window, document) {
  'use strict';
  var states = [];
  var scheduled = false;
  function clean(value, limit) {
    return String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  }
  function safeProductPath(value) {
    var path = String(value || '');
    return /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,3})?\/)?products\/[a-z0-9_-]+(?:\?variant=\d+)?$/i.test(path) ? path : '';
  }
  function validQuantity(value) {
    return /^[1-9]\d*$/.test(String(value)) && Number(value) <= 100 ? String(Number(value)) : '';
  }
  function optionsText(data, variant) {
    var labels = { pcd: 'Bolt pattern', et: 'Offset (mm)', offset: 'Offset (mm)', 'pcd et': 'Bolt pattern / offset' };
    return (variant.options || []).map(function (value, i) {
      var name = String((data.options || [])[i] || '');
      if (name === 'Title' && value === 'Default Title') { return ''; }
      return (labels[name.toLowerCase().trim()] || name || 'Option') + ': ' + value;
    }).filter(Boolean).join('; ');
  }
  function inquiryHref(root, title, productPath, data, variant, quantity, search) {
    var path = safeProductPath(String(productPath || '').split('?')[0]);
    if (!path || !variant || !/^\d+$/.test(String(variant.id))) { return ''; }
    var base = /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,3})?\/)?$/i.test(root || '') ? root : '/';
    var fields = [
      ['wo_from', 'product'], ['wo_product', clean(title, 180)],
      ['wo_options', clean(optionsText(data, variant), 400)],
      ['wo_sku', clean(variant.sku, 100)], ['wo_quantity', validQuantity(quantity)],
      ['wo_product_url', path + '?variant=' + variant.id]
    ];
    if (window.URLSearchParams) {
      var preview = new window.URLSearchParams(search || '').get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) { fields.push(['preview_theme_id', preview]); }
    }
    return base + 'pages/contact-us?' + fields.filter(function (pair) { return pair[1] !== ''; })
      .map(function (pair) { return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]); }).join('&');
  }
  function contactContext(params, origin) {
    if (params.get('wo_from') !== 'product') { return null; }
    var path = safeProductPath(params.get('wo_product_url'));
    var title = clean(params.get('wo_product'), 180);
    if (!path || !title) { return null; }
    var choices = clean(params.get('wo_options'), 400);
    var sku = clean(params.get('wo_sku'), 100);
    var count = validQuantity(params.get('wo_quantity'));
    var lines = ['I am interested in: ' + title];
    if (choices) { lines.push('Options: ' + choices); }
    if (sku) { lines.push('SKU: ' + sku); }
    if (count) { lines.push('Quantity: ' + count); }
    lines.push('Product: ' + origin + path, '', 'My question: ');
    return { title: title, path: path, message: lines.join('\n') };
  }
  function sortSizeText(value) {
    return String(value || '').split(',').map(function (part, i) { return { text: part.trim(), index: i }; })
      .filter(function (part) { return part.text; })
      .sort(function (a, b) {
        var left = a.text.match(/\d+(?:\.\d+)?/g) || [], right = b.text.match(/\d+(?:\.\d+)?/g) || [];
        if (!left.length || !right.length) { return left.length ? -1 : (right.length ? 1 : a.index - b.index); }
        for (var i = 0; i < Math.min(left.length, right.length); i++) {
          var difference = Number(left[i]) - Number(right[i]);
          if (difference) { return difference; }
        }
        return left.length - right.length || a.index - b.index;
      }).map(function (part) { return part.text; }).join(', ');
  }
  function updateMobile() {
    scheduled = false;
    var shown = false;
    var active = document.activeElement;
    var editing = active && /^(INPUT|TEXTAREA|SELECT)$/i.test(active.tagName);
    states = states.filter(function (state) { return document.documentElement.contains(state.root); });
    states.forEach(function (state) {
      var show = state.valid && window.innerWidth <= 767 && !editing && state.form.getBoundingClientRect().bottom < 80;
      state.bar.hidden = !show;
      shown = shown || show;
    });
    document.body.classList.toggle('wo-mobile-purchase-visible', shown);
  }
  function scheduleMobile() {
    if (scheduled) { return; }
    scheduled = true;
    if (window.requestAnimationFrame) { window.requestAnimationFrame(updateMobile); }
    else { window.setTimeout(updateMobile, 16); }
  }
  function initProduct(root) {
    if (root.getAttribute('data-wo-tools-ready') === 'true') { return; }
    var form = document.getElementById(root.getAttribute('data-wo-form-id'));
    if (!form) { return; }
    var dataNode = form.querySelector('[data-wo-product-json]');
    var master = form.querySelector('select[name="id"]');
    var qty = form.querySelector('input[name="quantity"]');
    var bar = root.querySelector('[data-wo-mobile-purchase]');
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    if (!data || !Array.isArray(data.variants) || !master || !qty || !bar || String(data.id) !== root.getAttribute('data-wo-product-id')) { return; }
    var links = root.querySelectorAll('[data-wo-ask-product]');
    var fallbackLinks = Array.prototype.map.call(links, function (link) { return link.getAttribute('href'); });
    var price = bar.querySelector('[data-wo-mobile-price]');
    var choices = bar.querySelector('[data-wo-mobile-options]');
    var state = { root: root, form: form, bar: bar, valid: false };
    function refresh() {
      var variant = data.variants.filter(function (item) { return String(item.id) === String(master.value); })[0];
      state.valid = !!variant;
      if (!variant) {
        for (var j = 0; j < links.length; j++) { links[j].setAttribute('href', fallbackLinks[j]); }
        bar.hidden = true;
        scheduleMobile();
        return;
      }
      var href = inquiryHref(root.getAttribute('data-wo-root'), root.getAttribute('data-wo-product-title'), root.getAttribute('data-wo-product-url'), data, variant, qty.value, window.location.search);
      if (href) { for (var i = 0; i < links.length; i++) { links[i].setAttribute('href', href); } }
      if (price) { price.textContent = variant.money || ''; }
      if (choices) { choices.textContent = (variant.available ? '' : 'Out of stock · ') + optionsText(data, variant); }
      scheduleMobile();
    }
    form.addEventListener('change', refresh);
    form.addEventListener('input', refresh);
    form.addEventListener('click', refresh);
    window.addEventListener('variantChange', refresh);
    states.push(state);
    root.setAttribute('data-wo-tools-ready', 'true');
    refresh();
  }
  function initContact() {
    var message = document.getElementById('wo-contact-message');
    if (!message || !window.URLSearchParams || message.getAttribute('data-wo-context-ready') === 'true') { return; }
    var context = contactContext(new window.URLSearchParams(window.location.search), window.location.origin);
    if (!context) { return; }
    // Keep text that a customer has typed, including a failed submission restored by Shopify.
    if (!message.value.trim()) { message.value = context.message; }
    var box = document.querySelector('[data-wo-contact-context]');
    if (box) {
      var title = box.querySelector('[data-wo-contact-context-text]');
      var link = box.querySelector('[data-wo-contact-product-link]');
      if (title) { title.textContent = 'Product question: ' + context.title; }
      if (link) {
        var href = context.path;
        var preview = new window.URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) { href += (href.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + encodeURIComponent(preview); }
        link.setAttribute('href', href);
      }
      box.hidden = false;
    }
    message.setAttribute('data-wo-context-ready', 'true');
  }
  function boot() {
    var products = document.querySelectorAll('[data-wo-product-tools]');
    for (var i = 0; i < products.length; i++) { initProduct(products[i]); }
    var specs = document.querySelectorAll('[data-wo-sort-sizes]');
    for (var s = 0; s < specs.length; s++) { specs[s].textContent = sortSizeText(specs[s].textContent); }
    initContact();
    if (states.length) { scheduleMobile(); }
  }
  window.WheelsOutletExperience = {
    inquiryHref: inquiryHref, contactContext: contactContext, safeProductPath: safeProductPath,
    sortSizeText: sortSizeText, validQuantity: validQuantity, initProduct: initProduct, initContact: initContact, updateMobile: updateMobile
  };
  window.addEventListener('scroll', function () { if (states.length) { scheduleMobile(); } }, { passive: true });
  window.addEventListener('resize', function () { if (states.length) { scheduleMobile(); } }, { passive: true });
  document.addEventListener('focusin', function () { if (states.length) { scheduleMobile(); } });
  document.addEventListener('focusout', function () { if (states.length) { scheduleMobile(); } });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window, document);
